import React from 'react'
import { View, StyleSheet } from 'react-native'

import BotHeader from './BotHeader'
import AssistantProgress from './AssistantProgress'

export default function BotMessagePlaceholder({ projectId, assistantId }) {
    return (
        <View style={localStyles.container}>
            <View style={localStyles.headerContainer}>
                <BotHeader projectId={projectId} assistantId={assistantId} />
            </View>
            <View style={localStyles.progressContainer}>
                <AssistantProgress activity={{ phase: 'preparing' }} compact={true} />
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        paddingVertical: 8,
        marginLeft: 14,
        borderRadius: 4,
    },
    headerContainer: {
        marginTop: 8,
    },
    // Matches MessageItemBody's messageContentContainer (24px avatar + 12px gap), so the
    // card lines up with the text of the messages above it.
    progressContainer: {
        marginLeft: 36,
    },
})
